define('maps/layers/tracklayer',["require", "exports", "../../baseline/colors"], function (require, exports, colors_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TrackLayer = void 0;
    var flightPathWeight = 5;
    var TrackLayer = /** @class */ (function () {
        function TrackLayer(track) {
            this.lines = [];
            this.track = track;
        }
        TrackLayer.prototype.onAddGoogle = function (googleMap) {
            this.googleMap = googleMap;
        };
        // Called when track data has changed (such as by trimming)
        TrackLayer.prototype.update = function () {
            // Remove previous layers
            for (var _i = 0, _a = this.lines; _i < _a.length; _i++) {
                var line = _a[_i];
                line.setMap(null);
            }
            this.lines.length = 0;
            // Draw flight path
            var segments = this.track.segments();
            for (var i = 0; i < segments.length; i++) {
                var segment = segments[i];
                this.lines[i] = new google.maps.Polyline({
                    map: this.googleMap,
                    path: segment.data,
                    strokeColor: (0, colors_1.mapColor)(segment.mode),
                    strokeWeight: flightPathWeight
                });
            }
        };
        TrackLayer.prototype.onRemove = function () {
            this.googleMap = undefined;
        };
        return TrackLayer;
    }());
    exports.TrackLayer = TrackLayer;
});
//# sourceMappingURL=/assets/javascripts/maps/layers/tracklayer.js.map;
